import React from 'react';
// import PropTypes from 'prop-types'
// import { AlertTitle } from '@mui/material';
import { Alert as MuiAlert, AlertTitle } from '@mui/material';
// import { StyledAlert } from './style';

const Alert = ({ ...props }) => <MuiAlert {...props} />;

Alert.propTypes = {};

Alert.AlertTitle = AlertTitle;

export default Alert;
